import Icon from '@/components/ui/AppIcon';

interface Step {
  number: string;
  title: string;
  description: string;
  icon: string;
}

const HowItWorksSection = () => {
  const steps: Step[] = [
    {
      number: "01",
      title: "Start Conversation",
      description: "Begin your wellness journey with a friendly AI chat that understands your needs.",
      icon: "ChatBubbleLeftIcon"
    },
    {
      number: "02",
      title: "Share Your Goals",
      description: "Tell us about your lifestyle, preferences, and wellness objectives at your own pace.",
      icon: "UserCircleIcon"
    },
    {
      number: "03",
      title: "Get Your Plan",
      description: "Receive a personalized wellness plan with movement, meditation, and nutrition guidance.",
      icon: "DocumentTextIcon"
    },
    {
      number: "04",
      title: "Discover Products",
      description: "Explore healthy food recommendations that align with your lifestyle plan.",
      icon: "ShoppingBagIcon"
    },
    {
      number: "05",
      title: "Adjust & Grow",
      description: "Continue the conversation to refine your plan and get ongoing support.",
      icon: "ArrowPathIcon"
    }
  ];

  return (
    <section className="py-16 md:py-24 px-4 bg-background">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            How It <span className="text-primary">Works</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Five simple stages to transform your wellness journey with AI-powered guidance.
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-0.5 bg-border" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step Number Circle */}
                <div className="relative z-10 w-16 h-16 mx-auto mb-4 bg-primary rounded-full flex items-center justify-center shadow-soft-md">
                  <span className="text-2xl font-bold text-primary-foreground">
                    {step.number}
                  </span>
                </div>

                {/* Icon */}
                <div className="flex justify-center mb-4">
                  <div className="w-12 h-12 bg-surface rounded-lg flex items-center justify-center border border-border">
                    <Icon name={step.icon as any} size={24} className="text-primary" />
                  </div>
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="text-lg font-semibold text-text-primary mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-text-secondary leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;